/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import React, {useEffect, useState} from 'react';
import {Col, Container, Row} from 'react-bootstrap';
import {Glyphicon} from "../../../Common/GlyphIcon";
import {service as SpeciesService} from '../../../../Services/SpeciesService';
import {useMakePageRequest,} from "../../../../Hooks/RequestHooks";

import {useContextIndependentPage} from "../../../../Hooks/ContextBuilderHooks";
import {useClassNames} from "../../../../Hooks/StyleHooks";

import {StreamBankPageHeader} from "../../../Common/StreamBankPageHeader";
import {SpeciesTable} from "./SpeciesTable/SpeciesTable";
import {AddSpeciesModal} from "./Modals/AddSpeciesModal";
import {EditSpeciesModal} from "./Modals/EditSpeciesModal";
import {SpeciesEmptyMessageFooter} from "./SpeciesTable/SpeciesEmptyMessageFooter";

export const SpeciesIndexPage = props => {
    useContextIndependentPage(props);

    const classNames = useClassNames('sb-species-view-page');
    const makePageRequest = useMakePageRequest();

    const [species, setSpecies] = useState(null);
    const [editingSpecies, setEditingSpecies] = useState(null);

    const {
        title = "Global Species List",
        addSpeciesButtonLabel = "Add Species",
        columnDefinitions = [],
        filterComponent = null,
        addModalComponent: AddModalComponent = AddSpeciesModal,
        editModalComponent: EditModalComponent = EditSpeciesModal,
        getSpeciesPromise = (_ => SpeciesService.Get()),
        sortColumn
    } = props;

    let ModalComponent = editingSpecies?.speciesId ? EditModalComponent : AddModalComponent;

    useEffect(() => {
        loadData();
    }, []);

    const loadData = (species) => {
        void makePageRequest(
            getSpeciesPromise,
            (species) => {
                setSpecies(species?.result || []);
            }
        );
    };

    const openSpeciesEditor = (id) => {
        const target = id && species?.find(x => x.speciesId === id);
        if(target) {
            setEditingSpecies({...target});
        } else {
            setEditingSpecies({
                speciesTypeId: 1,
                speciesNativityId: 1,
                speciesInvasivityId: 0,
                isDefault: true,
            });
        }
    };

    return <Container className={classNames}>
        <StreamBankPageHeader
            Title={title}
        />

        <ModalComponent
            show={!!editingSpecies}
            species={editingSpecies}
            onHide={() => void setEditingSpecies(null)}
            onReload={loadData}
        />

        <Row>
            <Col xs={12} md={6}><h2>{title}</h2></Col>
            { !!AddModalComponent ?
                <Col xs={12} md={6}>
                        <a type="button" className="float-right h3 btn btn-link" onClick={() => void openSpeciesEditor()} >
                            <Glyphicon glyph="plus-sign" /> {addSpeciesButtonLabel}
                        </a>
                </Col>
            : null }
        </Row>
        <Row>
            <Col xs={12}>
                <SpeciesTable
                    Data={species}
                    FilterComponent={filterComponent}
                    OnEditClick={(id) => void openSpeciesEditor(id)}
                    usesContext={false}
                    emptyMessageFooter={
                        <SpeciesEmptyMessageFooter
                            addSpeciesButtonLabel={addSpeciesButtonLabel}
                            addModalComponent={AddModalComponent}
                            onReload={loadData}
                        />
                    }
                    columnDefinitions={columnDefinitions}
                    sortColumn={sortColumn}
                />
            </Col>
        </Row>
    </Container>;
};


